module.exports = __webpack_public_path__ + "img/IMG_20190403_134159.642a0a22.jpg";